import { graphql } from "../gql";

export const startRuleTestRunMutationDoc = graphql(`
  mutation startRuleTestRun($input: StartRuleTestRunInput!) {
    startRuleTestRun(input: $input) {
      ruleId
      workflowId
    }
  }
`);
